import React from 'react';

import { SelectionCard } from 'src/app/shared/components/payments';

import { useAmountInput } from './hooks/useAmountInput';
import { useTracking } from './hooks/useTracking';

export function AmountInput(): React.JSX.Element {
	const {
		data: {
			amount,
			amountErrorMessage,
			currencySymbol,
			currencySymbolPosition,
			decimalSeparator,
			showFractionNumber,
			isSelected,
			label,
		},
		actions: { setAmount },
	} = useAmountInput();

	const { trackAmountInputFocus } = useTracking();

	return (
		<SelectionCard
			data-qa="custom-amount-input"
			type="amountInput"
			currencySymbol={currencySymbol}
			currencySymbolPosition={currencySymbolPosition}
			decimalSeparator={decimalSeparator}
			showFractionNumber={showFractionNumber}
			selected={isSelected}
			onChange={setAmount}
			label={label}
			value={amount}
			onFocus={trackAmountInputFocus}
			error={amountErrorMessage}
		/>
	);
}
